module.exports = __webpack_public_path__ + "img/zbdanwei.6b9ca464.png";